import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton
} from '@material-ui/core';
import useStyles from './styles';


const IgnoreMappingModal = ({chargeName, open, setOpen, onConfirm}) => {
  const classes = useStyles();
  const chargeProductData = {
    catalogName: '',
    sku: 'Ignore',
    revenueCategory1: '',
    revenueCategory2: '',
    revenueCategory3: '',
    revenueCategory4: '',
    replenishment: '',
    cost: 0,
    catalogBrand: '',
    manufacturer: '',
    loyaltyProgram: ''
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
      PaperProps={{
        className: classes.dialogRoot
      }}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle id="ignore-dialog" className="px-3">
        <div className="flex justify-end items-center">
          <IconButton
            onClick={() => setOpen(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="px-8 pb-5 relative text-center">
        <div className="p-8 text-18 font-bold">
          {`Are you sure you want to ignore ${chargeName}?`}
        </div>
      </DialogContent>
      <DialogActions className="justify-between py-6">
        <Button
          variant="outlined"
          onClick={() => setOpen(false)}
          size="small"
          className="uppercase ml-5"
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => onConfirm({chargeName, chargeProductData})}
          size="small"
          className="uppercase mr-5"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IgnoreMappingModal;
